import { TooltipProvider, TooltipContent, TooltipTrigger, TooltipRoot } from './tooltip-base.component';

import { cn } from '@/utils/cn-tw-merge';

interface TooltipProps {
  children: React.ReactNode;
  message: string;
  className?: string;
}

export function Tooltip({ children, message, className }: TooltipProps) {
  return (
    <TooltipProvider>
      <TooltipRoot>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className={cn(
          'z-50 overflow-hidden rounded-md bg-gray-900 p-3 text-sm text-gray-50 shadow-md',
          'max-w-[90vw] break-words whitespace-normal text-base',
          'animate-in fade-in-0 zoom-in-95',
          'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
          'data-[side=bottom]:slide-in-from-top-2',
          'data-[side=left]:slide-in-from-right-2',
          'data-[side=right]:slide-in-from-left-2',
          'data-[side=top]:slide-in-from-bottom-2',
          'dark:border-slate-800 dark:bg-slate-950 dark:text-slate-50',
          className,
        )}
        >
          {message}
        </TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  );
}
